import Vue from "vue";
import { $api } from "../services/index";

Vue.mixin({
    computed: {
        $api: () => $api
    }
});
